import { get } from 'lodash';
import APIClient from '../../../../../common/services/APIClient';
import { fetchEdgeControllersData } from '../../../shared/lib/fetchEdgeControllersData';
import { isDirectlySupervisor } from '../../../../../common/services/HasAccess';

export const FETCH_EDGE_CONTROLLER_DEVICE = 'edgeControllerDetails/FETCH_DEVICE';
export const FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS = 'edgeControllerDetails/FETCH_DEVICE_SUCCESS';
export const FETCH_EDGE_CONTROLLER_DEVICE_FAILURE = 'edgeControllerDetails/FETCH_DEVICE_FAILURE';
export const CLEAR_EDGE_CONTROLLER_DEVICE = 'edgeControllerDetails/CLEAR_DEVICE';

export const fetchEdgeControllerDevice = (deviceId) => async (dispatch, getState) => {
  dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE });

  const {
    login: { user },
  } = getState();

  const isDomesticSupervisor = isDirectlySupervisor(user);

  try {
    const devices = await fetchEdgeControllersData({ isDomesticSupervisor });
    const device = devices.find(({ device_id }) => device_id === deviceId) || null;

    if (device) {
      const releaseResp = await APIClient.get(`/plazas/core-devices/${device.customer_id}/${device.device_id}/release`).catch(() => ({
        data: null,
      }));
      const componentVersions = get(releaseResp, 'data.releases[0].componentVersions') || {};

      dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS, payload: { ...device, componentVersions } });
    } else {
      dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS, payload: null });
    }
  } catch {
    dispatch({ type: FETCH_EDGE_CONTROLLER_DEVICE_FAILURE });
  }
};

export const clearEdgeControllerDevice = () => ({ type: CLEAR_EDGE_CONTROLLER_DEVICE });
